import { getFields } from '../../../../utils';

const fields = ['birthUser', 'email', 'cellphone', 'fullName'];

const schema = getFields(fields);

schema.email.label = 'E-mail de cadastro';

schema.fullName.label = 'Nome';

schema.contracts = {
    id: 'contracts',
    label: 'Contrato(s) selecionado(s)',
    required: true,
    type: 'select',
    requiredMessage: 'Selecione ao menos um contrato',
};

schema.typeUser = {
    id: 'typeUser',
    label: 'Tipo de usuário',
    value: 'MCE',
    required: true,
    type: 'radio',
    options: [
        { codigo: 'MCE', nome: 'Auxiliar' },
        { codigo: 'RH', nome: 'Administrador' },
    ],
};

schema.position = {
    id: 'position',
    label: 'Cargo',
    required: true,
    type: 'text',
};

schema.permissions = {
    id: 'permissions',
    label: ' ',
    required: true,
    type: 'checkbox',
    options: [
        {
            codigo: 1,
            nome: 'Dados da empresa',
        },
        {
            codigo: 2,
            nome: 'Dados de beneficiário',
        },
        {
            codigo: 4,
            nome: 'Faturamento',
        },
        {
            codigo: 7,
            nome: 'Dados do contrato',
        },
        {
            codigo: 3,
            nome: 'Movimentação cadastral',
        },
        {
            codigo: 5,
            nome: 'Central de ajuda',
        },
    ],
};

export default schema;
